// removed by extract-text-webpack-plugin
module.exports = {"login":"Login__login___1bVJG","man":"Login__man___2MZ2K","logo":"Login__logo___3jRzv","container":"Login__container___2qJ66","line":"Login__line___2L5Br","signup":"Login__signup___2_OPB","h2":"Login__h2___ZdHbe","button":"Login__button___2myrA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.scss
// module id = csQ0
// module chunks = 0